import React, { useEffect, useState } from "react";
import { useAnnouncements } from "./AnnoucementsContext";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Dialog,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { upperCase } from "lodash";

const AnnouncementLinks = () => {
  const [open, setOpen] = useState(false);
  const {
    announcement,
    links,
    selectedLinkBtn,
    setAnnouncement,
    setLinks,
    setSelectedLinkBtn,
  } = useAnnouncements();

  useEffect(() => {
    setOpen(selectedLinkBtn);
  }, [selectedLinkBtn]);

  const onClose = (e, reason) => {
    setSelectedLinkBtn(false);
  };

  const handleChange = (e) => {
    const name = e.target.name.toLowerCase();
    const value = e.target.value;
    setSelectedLinkBtn(false);
    setAnnouncement((prev) => ({ ...prev, [name]: value }));
  };

  return (
    announcement &&
    links && (
      <Dialog open={open} onClose={onClose}>
        <IconButton
          aria-label="close"
          sx={{
            position: "absolute",
            right: 20,
            top: 8,
          }}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
        <Card sx={{ borderRadius: 3, overflow: "auto" }}>
          <CardHeader
            title={<font className="layer-title"> Links </font>}
            align="center"
            className={"styledtablerow"}
          />
          <CardContent sx={{ padding: 1, paddingLeft: 0, paddingRight: 0 }}>
            <FormControl>
              <InputLabel id="announcement-Icon-label"> Link </InputLabel>
              <Select
                size="small"
                labelId="announcements-links"
                label="Link"
                id="announcement-link"
                name="link"
                value={announcement.link}
                onClose={onClose}
                onChange={handleChange}
                defaultOpen
              >
                {links.map((eachChild) => (
                  <MenuItem value={eachChild} key={upperCase(eachChild)}>
                    {eachChild}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {!links && (
              <Box
                sx={{
                  display: "flex",
                  alignContent: "center",
                  alignItems: "center",
                  padding: 10,
                  width: "100%",
                }}
              >
                <CircularProgress sx={{ margin: "auto" }} />
              </Box>
            )}
          </CardContent>
        </Card>
      </Dialog>
    )
  );
};

export default AnnouncementLinks;
